export enum WriteOffSectionTabItem {
  reimbursementItems = 'reimbursement-items',
  reimbursementRecords = 'reimbursement-records',
}
